/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Grid, Tab, Tabs, styled } from "@mui/material";
import Card from "../../components/Cards/Card";
import { useQlik } from "../../context/Qlik";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";

const LayoutCardsWrapper = styled("div")({
	alignItems: "center",
	display: "flex",
	flexDirection: "column",
	height: "100%",
	justifyContent: "flex-start",
	width: "100%",
});

const LayoutCardWrapper = styled("div")({
	borderRadius: "16px",
	display: "flex",
	width: "100%",
	paddingRight: "10px",
});

function PanoramaDesktop({ app, config }) {
	const { selections } = useSelections();
	const [showFullCard, setPosCard] = useState(true);
	const [filterUpdate, sendFilterUpdate] = useState(0);
	const tabList = ["Sell Out", "Sell In", "Positivação"];
	const { setSwitchOnDemand } = useQlik();
	const [alignment, setAlignment] = useState("Sell Out");
	const [legendDate, setLegendDate] = useState("");
	const legends = [
		{
			type: "bar",
			iconColor: "#80D2FF",
			name: `Realizado ${legendDate}`,
		},
		{
			type: "bar",
			iconColor: "#009AD9",
			name: "Média 3 meses",
		},
		{
			type: "bar",
			iconColor: "#456D96",
			name: "Máxima 3 meses",
		},
		{
			type: "line",
			iconColor: "#F98561",
			name: `Meta ${legendDate}`,
		},
	];

	const initializeField = () => {
		app.field("%Selecao").selectMatch("Sell Out");
	};

	const checkPosCardState = (selections) => {
		if (selections.length) {
			const [analysisField, monthYearField] = [
				selections.find((s) => s.qField === "%Selecao"),
				selections.find((s) => s.qField === "Mês/Ano"),
			];

			const selectedAnalysis = analysisField?.qSelectedCount === 1;
			const selectedMonthYear = monthYearField?.qSelectedCount === 1;

			setPosCard(
				analysisField?.qSelected !== "Positivação" ||
					(selectedAnalysis && selectedMonthYear)
			);
		}
		sendFilterUpdate(filterUpdate);
	};

	const fetchDateValue = () => {
		if (app) {
			let dateId = "RNfJYF";
			setTimeout(() => {
				return app.visualization.get(dateId).then((res) => {
					const date =
						res.model.layout.qHyperCube.qGrandTotalRow[0].qText;
					setLegendDate(date);
				});
			}, 500);
		}
	};

	useEffect(() => {
		if (app) {
			initializeField();
			fetchDateValue();
		}
		setSwitchOnDemand(false);
	}, []);

	useEffect(() => {
		checkPosCardState(selections);
		fetchDateValue();
	}, [selections, fetchDateValue]);

	const handleChange = (event, newAlignment) => {
		app.field("%Selecao").selectMatch(tabList[newAlignment]);
		setAlignment(tabList[newAlignment]);
		sendFilterUpdate(newAlignment);
	};

	return (
		<div className="app panorama">
			<div className="appContent">
				<LayoutCardsWrapper>
					<LayoutCardWrapper>
						<Grid
							className="title-wrapper"
							container
							direction="row"
							justifyContent={"space-between"}
							alignItems={"center"}
						>
							<h1 className="title">Panorama</h1>

							<Box
								className="toggle"
								style={{
									margin: "0px 2px 4px",
									paddingBottom: "8px",
								}}
								color="primary"
								sx={{}}
							>
								<Tabs
									value={filterUpdate}
									onChange={handleChange}
									aria-label="basic tabs example"
									style={{
										marginTop: "0px",
										paddingTop: "0px",
										textAlign: "center",
									}}
								>
									<Tab
										label={
											<span className="toggle-button">
												Sell Out
											</span>
										}
									/>
									<Tab
										label={
											<span className="toggle-button">
												Sell In
											</span>
										}
									/>
									<Tab
										label={
											<span className="toggle-button">
												Positivação
											</span>
										}
									/>
								</Tabs>
							</Box>
						</Grid>
					</LayoutCardWrapper>

					<Grid container rowGap={2}>
						{/* KPIS */}
						<Grid item container xs={12}>
							<LayoutCardWrapper>
								<Grid
									container
									direction="row"
									justifyContent={"space-between"}
									alignItems={"center"}
									columnSpacing={2}
									className="contianer-kpis-panorama"
									style={{
										width: "100%",
										height: "16vh",
									}}
								>
									<Grid item xs={12} lg={3}>
										<Card
											header={{
												hardTitle: "Meta",
											}}
											style={{
												width: "100%",
												height: "16vh",
											}}
											classStyle={"row-header"}
										>
											{showFullCard ? (
												<NativeObject
													className="kpiValueBold"
													app={app}
													key="kNvmzXS"
													reference={{
														id: "kNvmzXS",
													}}
												/>
											) : (
												<span className="filter-warning">
													Selecione somente 1 Ano e
													Mes para análise com Meta de
													Positivação
												</span>
											)}
										</Card>
									</Grid>
									<Grid item xs={12} lg={3}>
										<Card
											header={{
												hardTitle:
													"Distribuidores abaixo de 75%",
											}}
											style={{
												width: "100%",
												height: "16vh",
											}}
											classStyle={"row-header"}
										>
											<NativeObject
												className="kpiValueBold"
												app={app}
												key="JyRzr"
												reference={{ id: "JyRzr" }}
											/>
										</Card>
									</Grid>
									<Grid item xs={12} lg={3}>
										<Card
											header={{
												hardTitle:
													"Distribuidores entre 76% e 99%",
											}}
											style={{
												width: "100%",
												height: "16vh",
											}}
											classStyle={"row-header"}
										>
											<NativeObject
												className="kpiValueBold"
												app={app}
												key="wPhEt"
												reference={{ id: "wPhEt" }}
											/>
										</Card>
									</Grid>
									<Grid item xs={12} lg={3}>
										<Card
											header={{
												hardTitle:
													"Distribuidores acima de 100%",
											}}
											style={{
												width: "100%",
												height: "16vh",
											}}
											classStyle={"row-header"}
										>
											<NativeObject
												className="kpiValueBold"
												app={app}
												key="ePZmw"
												reference={{ id: "ePZmw" }}
											/>
										</Card>
									</Grid>
								</Grid>
							</LayoutCardWrapper>
						</Grid>
						{/* DISTRIBUTOR GRAPHS */}
						<Grid item container xs={12}>
							<LayoutCardWrapper>
								<Grid
									container
									direction="row"
									justifyContent={"space-between"}
									alignItems={"center"}
									columnSpacing={2}
									style={{
										height: "32vh",
										width: "100%",
									}}
								>
									<Grid
										item
										xs={12}
										lg={6}
										style={{
											height: "100%",
										}}
									>
										<Card
											header={{
												hardTitle:
													"Quantos distribuidores estão abaixo ou acima da meta?",
											}}
											style={{
												width: "100%",
												height: "100%",
											}}
											classStyle={"row-header"}
										>
											<NativeObject
												app={app}
												key="npJExFg"
												reference={{ id: "npJExFg" }}
												type="table"
											/>
										</Card>
									</Grid>
									<Grid
										item
										xs={12}
										lg={6}
										style={{
											height: "100%",
										}}
									>
										<Card
											header={{
												hardTitle:
													"Quais distribuidores puxam o resultado para baixo?",
											}}
											style={{
												width: "100%",
												height: "100%",
											}}
											classStyle={"row-header"}
											expandable
										>
											<NativeObject
												app={app}
												key="ybJZkBh"
												reference={{ id: "ybJZkBh" }}
												type="table"
											/>
										</Card>
									</Grid>
								</Grid>
							</LayoutCardWrapper>
						</Grid>
						{/* PERFORMANCE GRAPH */}
						<Grid item container xs={12}>
							<LayoutCardWrapper>
								<Grid
									container
									direction="row"
									justifyContent={"flex-start"}
									alignItems={"center"}
									style={{
										width: "100%",
										display: "flex",
										marginRight: "12px",
									}}
								>
									<Grid
										item
										xs={12}
										style={{
											height: "32vh",
										}}
									>
										<Card
											header={{
												hardTitle: "Performance",
												legends: legends,
												scale: false,
											}}
											style={{
												width: "100%",
												height: "100%",
											}}
											classStyle={"row-header"}
										>
											<NativeObject
												app={app}
												key="JAKcfDr"
												reference={{ id: "JAKcfDr" }}
												type="table"
											/>
										</Card>
									</Grid>
								</Grid>
							</LayoutCardWrapper>
						</Grid>
					</Grid>
				</LayoutCardsWrapper>
			</div>
		</div>
	);
}
PanoramaDesktop.defaultProps = {
	app: null,
	config: {},
};

PanoramaDesktop.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default PanoramaDesktop;
